<div class="container">
  <div *ngIf="featherIcon" id="alert-icon" class="feather-icon" [ngClass]="featherIcon"></div>
  <h3 *ngIf="title" id="alert-title" class="alert-title">{{title}}</h3>
  <p *ngIf="description" id="alert-description" class="alert-description">{{description}}</p>
  <button *ngIf="buttonText" id="alert-button" class="alert-button" (click)="handleButtonClick()">{{buttonText}}</button>
</div>
